module.exports = __webpack_public_path__ + "static/media/differential-fluid-exchange.84f3236f.svg";